/**
 * Header V2 - Scene A Product Slider
 * 
 * 逻辑：
 * - 产品数量 ≤ 3：静态Grid，不初始化Swiper
 * - 产品数量 > 3：初始化Swiper，每页3个，居中对齐
 */

(function () {
    'use strict';

    // 等待 Swiper 库加载
    function initSceneASlider() {
        const sliderEls = document.querySelectorAll('[data-scene-a-slider]');
        if (!sliderEls.length) return;

        // 检查 Swiper 是否可用
        if (typeof Swiper === 'undefined') {
            console.warn('Swiper library not loaded');
            return;
        }

        sliderEls.forEach((sliderEl) => {
            if (sliderEl.dataset.sceneASliderInitialized === 'true') return;

            const productsContainer = sliderEl.closest('.scene-a-products');
            if (!productsContainer) return;

            const productsCount = parseInt(
                productsContainer.dataset.productsCount,
                10
            );

            if (Number.isNaN(productsCount) || productsCount <= 3) return;

            sliderEl.dataset.sceneASliderInitialized = 'true';

            const paginationEl = productsContainer.querySelector(
                '.scene-a-products__pagination'
            );

            const swiperConfig = {
                slidesPerView: 1,
                spaceBetween: 24,
                loop: false,
            };

            if (paginationEl) {
                swiperConfig.pagination = {
                    el: paginationEl,
                    type: 'progressbar',
                };
            }

            new Swiper(sliderEl, swiperConfig);
        });
    }

    // DOM加载完成后初始化
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSceneASlider);
    } else {
        initSceneASlider();
    }

    // 如果 Swiper 是异步加载的，监听其加载完成
    window.addEventListener('load', () => {
        if (typeof Swiper !== 'undefined') {
            initSceneASlider();
        }
    });

})();
